import { Link } from "@tanstack/react-router";
import { Stack, Td, Text, Tr } from "@/components/ui";
import type { UsuarioAdmin } from "@/lib/types";
import type { DocumentoAuditEntry } from "../services/auditoria-service";
import { formatBytes } from "../utils/format-helpers";
import { AccionBadge } from "./AccionBadge";

/**
 * Fila desktop · cruza el `usuarioId` con el directorio que pasa el
 * padre (los admin ven email + fullName; los auditor solo ven el id
 * truncado porque no tienen acceso al listado de usuarios).
 */
export function DocumentoAuditRow({
  entry,
  usuario,
}: {
  entry: DocumentoAuditEntry;
  usuario: UsuarioAdmin | undefined;
}) {
  return (
    <Tr>
      <Td>
        <Text size="xs" c="dimmed" className="whitespace-nowrap">
          {new Date(entry.ocurridoAt).toLocaleString()}
        </Text>
      </Td>
      <Td>
        <AccionBadge accion={entry.accion} />
      </Td>
      <Td>
        <Link to="/solicitudes/$id" params={{ id: entry.solicitudId } as never} className="font-mono text-sm text-multiva-600 hover:underline">
          #{entry.numeroSolicitud}
        </Link>
      </Td>
      <Td>
        <Text size="sm">{entry.categoria}</Text>
      </Td>
      <Td>
        <Text size="sm" truncate className="max-w-60" title={entry.nombreOriginal}>
          {entry.nombreOriginal}
        </Text>
        <Text size="xs" c="dimmed" className="uppercase">
          .{entry.extension}
        </Text>
      </Td>
      <Td align="right">
        <Text size="xs" className="font-mono">
          {formatBytes(entry.tamanoBytes)}
        </Text>
      </Td>
      <Td>
        {usuario ? (
          <Stack gap={2}>
            <Text size="sm">{usuario.fullName ?? "—"}</Text>
            <Text size="xs" c="dimmed" className="font-mono">
              {usuario.email}
            </Text>
          </Stack>
        ) : (
          <Text size="xs" c="dimmed" className="font-mono">
            {entry.usuarioId.slice(0, 8)}…
          </Text>
        )}
      </Td>
      <Td>
        <Text size="xs" c="dimmed">
          {entry.motivoEliminacion ?? "—"}
        </Text>
      </Td>
    </Tr>
  );
}
